import React from "react";

import { SnackbarContext } from "../context/SnackbarContext";

export const withSnackbar = (Component) => (props) =>
  (
    <SnackbarContext.Consumer>
      {(context) => (
        <>
          <Component
            setSnackbarMessage={context.setMessage}
            setAlertSeverity={context.setSeverity}
            {...props}
          />
        </>
      )}
    </SnackbarContext.Consumer>
  );

/*
  This Higher Order component should be the primary way snackbar alerts are triggered in the app.
  Basically wrapping a component like this `withSnackbar(SomeComponent)` provides the component
  with a setSnackbarMessage() & setAlertSeverity() prop which can be triggered from anywhere in the component to pop
  up an alert. See src/views/VehicleDetail/VehicleDataWidget/VehicleDataWidget.jsx for an example
  of how this is used in the context of error handling. withSnackbar takes care of everything else.
 */
